export class ActionSettings {
    Range: boolean = false;
    AverageTime: boolean = false;
    WaveLength: boolean = false;
    Ior: boolean = false;
    Pulse: boolean = false;
}
